import { render, staticRenderFns } from "./RemoveEpisode.vue?vue&type=template&id=640dd21e"
import script from "./RemoveEpisode.vue?vue&type=script&lang=js"
export * from "./RemoveEpisode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports